module.exports = __webpack_public_path__ + "static/sponsorship_img-03-a-5c120ca4118a9f01c9576742405d7eb4.jpg";